import React from "react";
import Grid from "@mui/material/Unstable_Grid2/Grid2";

import styleCI from "./styleCI";
import { converDate, formatDate_Y_M_D } from "../../utils";
import moment from "moment";

export default function PackageInsurance(props) {
  const classes = styleCI();
  const { state } = props;
  const { detail } = state;

  const convertMoney = (money) => {
    return `${money}`.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  };

  const renderData = [
    {
      title: "Số hợp đồng",
      value: detail.certNum || "",
      color: "#3961A0",
      wordBreak: true,
      name: "cerNum",
    },
    {
      title: "Tổng phí bảo hiểm",
      value: `${convertMoney(detail.fees || 0)} VNĐ`,
      color: "#3961A0",
    },
    {
      title: "Tổng quyền lợi",
      value: `${convertMoney(detail.productAmount || 0)} VNĐ`,
      color: "#3961A0",
    },
    {
      title: "Quyền lợi còn lại",
      value: `${convertMoney(detail.totalAmountRemaining || 0)} VNĐ`,
      color: "#3961A0",
    },
    {
      title: "Chủ hợp đồng",
      value: detail?.buyerName || "",
      color: "#686868",
      capitalize: true,
    },
    {
      title: "Giới tính",
      value:
        detail?.buyerGender === 1
          ? "Nam"
          : detail?.buyerGender === 0
          ? "Nữ"
          : "",
      color: "#686868",
    },
    {
      title: "Ngày sinh",
      value: formatDate_Y_M_D(detail?.buyerDob)
        ? moment(formatDate_Y_M_D(detail?.buyerDob)).format("DD/MM/YYYY")
        : "",
      color: "#686868",
    },
    {
      title: "Số  điện thoại",
      value: detail?.buyerPhone || "",
      color: "#686868",
    },
    {
      title: "CMND/ CCCD",
      value: detail?.buyerPrivateId || "",
      color: "#686868",
    },
    {
      title: "Email",
      value: detail?.buyerEmail || "",
      color: "#686868",
    },
    {
      title: "Địa chỉ",
      value: detail?.buyerAddress,
      color: "#686868",
    },
    {
      title: "Nơi mua bảo hiểm",
      value: detail?.merchantTitle || "",
      color: "#686868",
    },
    {
      title: "Ngày tham gia đầu tiên",
      value:
        // moment(converDate(detail?.beginDate)).format("HH:mm, DD/MM/YYYY ") ||
        moment(converDate(detail?.beginDate)).format("DD/MM/YYYY") ||
        "",
      color: "#686868",
    },
    {
      title: "Ngày hiệu lực",
      value:
        moment(converDate(detail?.beginDate)).format("DD/MM/YYYY") ||
        "",
      color: "#686868",
    },
    {
      title: "Ngày hết hạn",
      value:
        moment(converDate(detail?.endDate)).format("DD/MM/YYYY") || "",
      color: "#686868",
    },
  ];

  return (
    <div className={classes.container_package_insurance}>
      <Grid container spacing={2}>
        {renderData.map((item, index) => (
          <Grid item key={index} xs={6} sm={4} md={4} lg={3}>
            <div className="item-grid-package-insurance">
              <div style={{ color: "#A0A0A0" }}>{item.title}</div>
              <div
                style={{
                  color: item.color,
                  fontWeight: "600",
                  wordBreak: item.wordBreak ? "break-all" : "",
                  textTransform: item.capitalize ? "capitalize" : "",
                }}
                onClick={() => {
                  if (item.name === "cerNum" && detail?.certLink) {
                    window.open(detail?.certLink, "_blank");
                  }
                }}
              >
                {item.value}
              </div>
            </div>
          </Grid>
        ))}
      </Grid>
    </div>
  );
}
